import { AllTrafficUsedType, TrafficUsedType } from "../biz/traffic";
import { httpApi } from "./basicHttpApi";
import { SubscriptionType } from "./fetchSubscriptionList";

export const fetchTrafficForSubscription = async (subscriptionId: number): Promise<TrafficUsedType> => {
  const uri = `/subscriptions/traffic/${subscriptionId}`;
  const result = await httpApi(uri, undefined, 'GET');
  console.log('fetchTrafficForSubscription', result);
  return result;
}

export const fetchTrafficUsed = async (subscriptions: SubscriptionType[]): Promise<AllTrafficUsedType> => {
  const result: AllTrafficUsedType = {};
  // FIXME 
  const resolved = await Promise.all(subscriptions.map(async subscription => {
    const traffic = await fetchTrafficForSubscription(subscription.id)
    result[subscription.id] = traffic;
  }))
  console.log('fetchTrafficUsed', { subscriptions, result, resolved })
  return result
}
